if (!customElements.get("product-modal")) {
  var swiper;
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        swiper = new Swiper(".modal-media--container ", {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-button-next-product",
            prevEl: ".swiper-button-prev-product",
          },
        });
        if (
          $("body").data("template") == "product" &&
          $("body").data("templatetype") != "bundle"  && $(this).data('hasvariant') == "true"
        ) {
          $(".modal-media--container .swiper-slide").hide();
          var selected_variant = $(".product-variants-all").data("calt");
          var selected_slides =
            '.modal-media--container .swiper-slide[data-alt="' +
            selected_variant +
            '"]';
          $(selected_slides).show();
          this.mql = window.matchMedia("(max-width: 750px)");
          if (this.mql.matches || $("body").data("template") != "product") {
            console.log("testt");
            $(".slider-mobile-gutter .product__media-item").hide();
            var selected_slides_mobile =
              '.slider-mobile-gutter .product__media-item[data-mediaalt="' +
              selected_variant +
              '"]';
            $(selected_slides_mobile).show();
          }
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        var cindex = 0;
        var mediaid = $(opener)
          .parent()
          .find(".product__media-toggle")
          .data("media-id");
        var count = 0;
        $(".product-media-modal__content .swiper-slide:visible").each(function (
          index
        ) {
          if ($(this).data("media") == mediaid) {
            cindex = count;
          }
          count++;
        });
        swiper.slideTo(cindex);
        swiper.update();

        super.show(opener);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}
